<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      :before-open="beforeOpen"
      v-model="tableForm"
      ref="crud"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="rectificationAttachListForm">
        <VUpload
          :disabled="formType == 'view'"
          :fileList="tableForm.rectificationAttachList"
        ></VUpload>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import VUpload from '@/views/components/v-upload';
import {
  getProjectList,
  getList,
  getDetail,
  update,
  remove,
} from '@/api/crmedical/device/rectifyRecord.js';

export default {
  components: { VUpload },
  data() {
    return {
      projectList: [],
      projectId: '',
      formType: '',
      tableForm: {},
      searchForm: { projectId: '' },
      loading: true,
      tableData: [],
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        searchMenuSpan: 9,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchMenuPosition: 'right',
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            editDisabled: true,
            search: true,
            type: 'select',
            dicData: [],
            searchClearable: false,
            props: {
              label: 'name',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择项目',
                trigger: 'change',
              },
            ],
          },
          {
            label: '任务名称',
            prop: 'taskName',
            editDisabled: true,
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '区域编号',
            prop: 'code',
            editDisabled: true,
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '区域名称',
            prop: 'areaName',
            editDisabled: true,
            search: true,
            maxlength: 20,
            showWordLimit: true,
            editDisabled: true,
          },
          {
            label: '区域全称',
            prop: 'fullName',
            editDisabled: true,
          },
          {
            label: '所属部门',
            prop: 'deptName',
            editDisabled: true,
          },
          {
            label: '整改类型',
            prop: 'rectificationTypeName',
            editDisabled: true,
          },
          {
            label: '整改人',
            prop: 'rectificationManName',
            editDisabled: true,
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '整改时间',
            prop: 'rectificationTime',
            editDisabled: true,
          },
          {
            label: '整改时间',
            prop: 'rectificationTimeCopy',
            hide: true,
            showColumn: false,
            viewDisplay: false,
            editDisplay: false,
            search: true,
            searchSpan: 9,
            type: 'datetimerange',
            searchRange: true,
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '工单编号',
            prop: 'orderCode',
            editDisabled: true,
          },
          {
            label: '备注',
            prop: 'rectificationDescription',
            hide: true,
            showColumn: false,
            type: 'textarea',
            overHidden: true,
            placeholder: '请输入 备注',
            span: 24,
            minRows: 2,
            maxlength: 200,
          },
          {
            label: '现场图片',
            prop: 'rectificationAttachList',
            hide: true,
            showColumn: false,
            formslot: true,
          },
        ],
      },
    };
  },
  watch: {
    'searchForm.projectId'(val) {
      if (val) {
        this.projectId = val;
      }
    },
  },
  async created() {
    let projectColumn = this.findObject(this.option.column, 'projectId');
    await getProjectList().then((res) => {
      this.projectList = res.data;
      projectColumn.dicData = this.projectList;
      this.searchForm.projectId = this.projectList[0] ? this.projectList[0].id : '';
      this.onLoad();
    });
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[2].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 370) {
            this.option.height = this.bodyHeight - 259;
          } else {
            this.option.height = this.bodyHeight - 370;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.height = this.bodyHeight - 370;
  },
  methods: {
    beforeOpen(done, type) {
      this.formType = type;
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.tableForm.id })
          .then(({ data }) => {
            this.tableForm = data;
            done();
          })
          .catch(() => {
            done();
          });
      }
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      let params = {
        ids: row.id,
      };
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(params);
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    searchReset() {
      this.searchForm = { projectId: this.projectId };
      this.tablePage.currentPage = 1;
      this.onLoad();
    },
    searchChange(params, done) {
      this.searchForm = params;
      if (this.searchForm.rectificationTimeCopy) {
        this.searchForm.startTime = this.searchForm.rectificationTimeCopy[0];
        this.searchForm.endTime = this.searchForm.rectificationTimeCopy[1];
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
      this.tablePage.currentPage = 1;
      this.onLoad();
      done();
    },
    onLoad(page) {
      if (!this.searchForm.projectId) {
        this.loading = false;
        return;
      }
      page = page || this.tablePage;
      this.loading = true;
      let params = Object.assign(
        { current: page.currentPage, size: page.pageSize },
        this.searchForm
      );
      params.rectificationTimeCopy = null; // 这个多余的字段不置空后端会报“运行时数据异常”
      getList(params).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>